import defaultAvatar from "../../../assets/sampleAvatar2.png";

export default function LikeNotification({
  senderUsername = "Unknown",
  senderAvatar,
  dailyUpdateTitle = "your memory",
  timeAgo = "",
  isUnread = false,
}) {
  const avatar = senderAvatar || defaultAvatar;

  const cardStyle = {
    backgroundColor: isUnread ? "rgba(60, 50, 80, 0.75)" : "rgba(50, 43, 64, 0.6)",
    border: isUnread
      ? "1px solid rgba(185, 151, 255, 0.45)"
      : "1px solid rgba(185, 151, 255, 0.15)",
    borderRadius: "20px",
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    backdropFilter: "blur(10px)",
    transition: "background-color 0.2s ease",
  };

  const avatarWrapperStyle = {
    minWidth: "40px",
    maxWidth: "40px",
    height: "40px",
  };

  const avatarImgStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    objectFit: "cover",
  };

  const textContainerStyle = {
    flex: 1,
    minWidth: 0,
  };

  const textStyle = {
    margin: 0,
    fontSize: "0.9rem",
    color: "#e0e0e0",
    lineHeight: 1.4,
  };

  const usernameStyle = {
    fontWeight: 700,
    color: "#ffffff",
  };

  const memoryTitleStyle = {
    color: "rgba(185, 151, 255, 0.8)",
    fontWeight: 400,
  };

  const timeStyle = {
    color: "rgba(185, 151, 255, 0.6)",
    fontSize: "0.75rem",
    marginTop: "2px",
    display: "block",
  };

  const heartStyle = {
    minWidth: "36px",
    height: "36px",
    borderRadius: "50%",
    backgroundColor: "rgba(185, 151, 255, 0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1rem",
    color: "var(--main-purple)",
    flexShrink: 0,
  };

  return (
    <div style={cardStyle}>
      {/* AVATAR */}
      <div style={avatarWrapperStyle}>
        <img
          src={avatar}
          alt={`${senderUsername}'s avatar`}
          style={avatarImgStyle}
        />
      </div>

      {/* TEXT */}
      <div style={textContainerStyle}>
        <p style={textStyle}>
          <span style={usernameStyle}>{senderUsername}</span> liked{" "}
          <span style={memoryTitleStyle}>{dailyUpdateTitle}</span>
        </p>
        <span style={timeStyle}>{timeAgo}</span>
      </div>

      {/* HEART ICON */}
      <div style={heartStyle}>
        <ion-icon name="heart" style={{ color: "var(--main-purple)" }}></ion-icon>
      </div>
    </div>
  );
}
